<template>
    <CollapsibleWidget size="small">
        <template #name>
            <span class="capitalize-text">{{ label }}</span>
        </template>

        <template #controls>
            <Badge
                v-if="selectedEditableIdsByGroup.length"
                :count="selectedEditableIdsByGroup.length"
                class="editable-group-checkbox__count-badge filter-badge-count"
            />
        </template>

        <LibraryCheckboxGroup v-model="selectedEditableIdsByGroup" :options="options" />
    </CollapsibleWidget>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import LibraryCheckboxGroup from "@/components/Campaign/LibraryCheckboxGroup.vue";
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import { useCreativeLibraryFiltersStore } from "@/store/pinia/creativeLibraryFilters";

const creativeLibraryFiltersStore = useCreativeLibraryFiltersStore();

const { groupName, label, options } = defineProps<{
    groupName: string;
    label: string;
    options: { label: string; value: string }[];
}>();

const selectedEditableIdsByGroup = computed({
    get: () => creativeLibraryFiltersStore.selectedEditableIdsByGroup[groupName] || [],
    set: (newValue: string[]) => {
        creativeLibraryFiltersStore.setSelectedGroupIdsByGroup(groupName, newValue);
    }
});
</script>
